// @ts-nocheck
import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useCallback } from 'react';

import { defaultInputStyles, defaultSxStyles } from './fieldsStyles';

const StyledTextField = styled(TextField)({
  '& .MuiInputBase-root': {
    height: '100%',
    padding: 0,
  },
  '& .MuiInputBase-input': {
    height: '100%',
    padding: '0 4px',
    fontSize: '14px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
});

const IntegerField = ({
  value,
  onChange,
  format = {},
  inputRef,
  onFocus,
  onBlur,
  ...props
}) => {
  const handleChange = useCallback(
    (e) => {
      const val = Number(e?.target?.value);
      if (!Number.isNaN(val)) {
        onChange(val);
      }
    },
    [onChange]
  );

  return (
    <StyledTextField
      type="number"
      fullWidth
      variant="outlined"
      value={value}
      onChange={handleChange}
      inputRef={inputRef}
      onFocus={onFocus}
      onBlur={onBlur}
      size="small"
      slotProps={{
        htmlInput: {
          step: 1,
          style: {
            ...defaultInputStyles,
            ...format,
          },
        },
      }}
      sx={{
        ...defaultSxStyles,
        ...props.sx,
      }}
      {...props}
    />
  );
};

IntegerField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  format: PropTypes.shape({}).isRequired,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  sx: PropTypes.shape({}).isRequired,
  inputProps: PropTypes.shape({}).isRequired,
};

export default IntegerField;
